module.exports = __webpack_public_path__ + "static/img/zs.1783997848725.png";